<template>
  <form
    :id="form.id? `form_${form.id}`: 'custom_form'"
    ref="form"
    class="osc_form"
    :action="action"
    method="post"
    novalidate="true"
    @submit.prevent="onSubmit"
  >
    <div v-if="loading" class="loading_overlay">
      <div class="loader" @click="cancel" />
    </div>
    <transition name="fade">
      <b-modal
        id="alert_modal"
        ref="alertModal"
        centered
        hide-header
        hide-footer
        @hidden="onHidden"
      >
        <div v-if="alert_msg" class="py-3 msg_content">
          <div :class="`text-${success? 'success': 'danger'}`">
            <strong class="mr-2">{{ success? "SUCCESS": "ERROR" }}:</strong>
            <div class="d-inline-block" v-html="alert_msg" />
          </div>
        </div>
      </b-modal>
    </transition>
    <div class="grid container">
      <template v-for="(field, i) in form.fields">
        <FormField
          v-if="field.fieldtype === 'hidden'"
          :id="field.fieldname"
          :key="`field_${i}`"
          :ref="field.fieldname"
          :field="field"
        />
        <div
          v-else-if="field.fieldtype === 'partial'"
          :id="field.fieldname"
          :key="`field_${i}`"
          class="row transparent"
        >
          <div class="col-12 px-0">
            <div class="blackTitle">{{ field.fieldlabel }}</div>
            <div class="partialContent" v-html="filterHTML(field.others)" />
          </div>
        </div>
        <div
          v-else-if="(field.fieldtype === 'checkbox' || field.fieldtype === 'radio') && (field.fieldlabel.length > 75 || field.others.length > 75)"
          :id="field.fieldname"
          :key="`field_${i}`"
          class="row transparent"
        >
          <template v-if="field.fieldlabel">
            <div v-if="field.others.length > 75" class="col-12 px-0">
              <div class="blackTitle">{{ field.fieldlabel }}</div>
            </div>
            <div v-else class="col-12">{{ field.fieldlabel }}</div>
          </template>
          <div class="col-12">
            <FormField :ref="field.fieldname" :field="field" />
          </div>
        </div>
        <div v-else :id="field.fieldname" :key="`field_${i}`" class="row">
          <template v-if="field.fieldname === 'amount'">
            <div class="col-12 px-0">
              <u>{{ field.fieldlabel }}</u>
            </div>
            <div class="col-12">
              <FormField :ref="field.fieldname" :field="field" />
            </div>
          </template>
          <template v-else>
            <div
              class="col-sm-4 col-5"
              :class="field.required? 'required_field': ''"
            >{{ field.fieldlabel }}</div>
            <div class="field_col col-sm-8 col-7">
              <FormField :ref="field.fieldname" :field="field" />
            </div>
          </template>
        </div>
      </template>
    </div>
    <h6 class="mt-2 text-osc">{{ $t('component.form.required_field_hint') }}</h6>
    <div class="text-center">
      <div v-if="recaptcha_able" class="my-3">
        <vue-recaptcha
          ref="recaptcha"
          class="d-inline-block"
          sitekey="6Leb2v4UAAAAABglNEp9emZ9LuaZtrt5geuN58vv"
          @verify="onCaptchaVerified"
          @expired="onCaptchaExpired"
        />
        <transition name="fade">
          <p v-if="!verified && recaptcha_error" class="text-danger my-2" v-html="recaptcha_error" />
        </transition>
      </div>
      <input class="btn btn-primary" type="submit" :value="$t('message.submit_btn')" />
    </div>
  </form>
</template>
<script>
import FormField from "@/components/FormField.vue";
import VueRecaptcha from "vue-recaptcha";
import _ from "lodash";

export default {
  name: "Form",
  components: { FormField, VueRecaptcha },
  props: ["form", "url", "footer", "action", "auto_submit", "is_edit"],
  data() {
    return {
      loading: false,
      request: null,
      alert_msg: null,
      success: false,
      verified: false,
      recaptcha_token: null,
      recaptcha_able: localStorage.getItem("recaptcha_able")
        ? localStorage.getItem("recaptcha_able") === "true"
        : true,
      recaptcha_error: null
    };
  },
  mounted() {
    if (this.auto_submit) {
      this.verified = true; // Pass recaptcha check
      this.recaptcha_able = false;
      this.onSubmit();
    }
  },
  methods: {
    onCaptchaVerified: function(recaptcha_token) {
      this.verified = true;
      this.alert_msg = null;
      this.recaptcha_token = recaptcha_token;
    },
    onCaptchaExpired: function() {
      this.verified = false;
      if (this.$refs.recaptcha) {
        this.$refs.recaptcha.reset();
        this.recaptcha_token = null;
      }
    },
    cancel() {
      if (this.request) {
        this.request.cancel("Cancel Previous Request");
      }
      this.loading = false;
    },
    onHidden(e) {
      e.preventDefault();
      if (this.success) {
        location.reload(true);
      } else if (!this.is_edit) {
        this.success = false;
        this.alert_msg = null;
        this.scrollTo(this.form.id ? `#form_${this.form.id}` : "#custom_form");
      }
      // else if (this.success) {
      //   location.reload(true);
      // }
    },
    onReset() {
      this.$refs["form"].reset();
      if (this.$refs.recaptcha) {
        this.$refs.recaptcha.reset();
      }
      this.$children.forEach(function(item) {
        if (item.field && item.field.fieldtype != "hidden") {
          item.value = null;
        }
      });
    },
    onSubmit(e) {
      if (!this.verified && this.recaptcha_able) {
        this.recaptcha_error = this.$t("component.form.captcha_error");
        // this.$refs.alertModal.show();
        return;
      } else {
        this.recaptcha_error = null;
      }

      let data = {};
      let other_fields = {}; // For donation
      let has_file = false;
      let validForm = true;
      let invalid_elm = null;
      this.$children.forEach(function(item) {
        if (item.field) {
          var validField = item.checkField();
          if (!validField) {
            validForm = false;
            if (invalid_elm == null) invalid_elm = item.field.fieldname;
          }
          if (item.field.fieldtype == "file") {
            has_file = true;
            if (typeof item.value != "string") {
              data[item.field.fieldname] = item.value;
            }
          } else if (item.field.fieldtype == "date") {
            data[item.field.fieldname] = item.value
              ? item.customFormatter(item.value)
              : null;
          } else if (typeof item.value == "string") {
            data[item.field.fieldname] = item.value;
          } else {
            data[item.field.fieldname] = JSON.stringify(item.value);
          }
          if (item.additional) {
            // Text value for Radio / Checkboxes / Dropdown
            for (var extra in item.additional) {
              if (extra.startsWith("custom_")) {
                let parentKey = extra.replace("custom_", "");
                if (data[parentKey] == "custom") {
                  data[parentKey] = item.additional[extra];
                }
              } else {
                data[extra] = item.additional[extra];
              }
            }
            // Object.assign(data, item.additional);
          }

          if (item.field.fieldname.startsWith("other_")) {
            var other_fieldname = item.field.fieldname.replace("other_", "");
            other_fields[other_fieldname] = data[item.field.fieldname];
          }
        }
      });

      // Temporarily disable local checking
      if (!validForm) {
        e.preventDefault();
        this.scrollTo(`.row#${invalid_elm}`);
        return false;
      }

      if (this.action) {
        this.$refs["form"].submit();
        return;
      }

      this.loading = true;
      this.request = this.CancelToken.source();
      var postOptions = { cancelToken: this.request.token };
      var postData = null;
      if (has_file) {
        postData = new FormData();
        for (var key in data) {
          postData.append(key, data[key]);
        }
        postData.append("recaptcha_token", this.recaptcha_token);
        postOptions["headers"] = { "Content-Type": "multipart/form-data" };

        if (this.url == "proposal/edit") {
          let token = localStorage.getItem("token");
          postOptions["headers"]["Authorization"] = "Bearer " + token;
        }
      } else {
        // postData = { data: data };
        // postOptions["headers"] = {'Content-Type': 'application/x-www-form-urlencoded'};
        postData = data;
        postData["recaptcha_token"] = this.recaptcha_token;

        if (!_.isEmpty(other_fields)) {
          postData["other"] = JSON.stringify(other_fields);
        }
      }

      console.log(postData);
      this.$http
        .post(this.url, postData, postOptions)
        .then(response => {
          this.success = response.data.success;
          if (response.data.success) {
            if (response.data.data) {
              let data = response.data.data;
              if (data.token) {
                localStorage.setItem("token", data.token);
              }
            }
            if (response.data.redirect) {
              var redirection = response.data.redirect;
              if (redirection.redirect) {
                this.$router.push(redirection.url);
              } else if (redirection.thank_you_msg) {
                this.alert_msg = redirection.thank_you_msg;
                this.$refs.alertModal.show();
                if (!this.is_edit) this.onReset();
              }
            }
          } else if (response.data.error) {
            throw { response: response };
          }
        })
        .catch(error => {
          if (!error || !error.response) return;
          this.alert_msg = null;
          var data = error.response.data;
          if (data && data.redirect) {
            this.$router.push(data.redirect.url);
          } else if (data && data.error) {
            if (typeof data.error == "string") {
              this.alert_msg = this.$t(`component.form.${data.error}`);
            } else {
              let invalid_elm = null;
              for (let error_field of data.error) {
                if (error_field.param !== undefined) {
                  if (error_field.param == "recaptcha_token") {
                    this.verified = false;
                    this.recaptcha_error = this.$t(
                      "component.form.captcha_error"
                    );
                  } else {
                    let field_elm = this.$refs[error_field.param];
                    if (field_elm) {
                      if (invalid_elm == null) invalid_elm = error_field;
                      // field_elm[0].error = this.$t(`component.form.${error_field.msg}`, { field: field_elm[0].field.fieldlabel } );
                      field_elm[0].error = error_field.msg;
                    }
                  }
                }
              }
              if (invalid_elm) {
                this.scrollTo(`.row#${invalid_elm.param}`);
              }
            }
          } else if (data && data.msg) {
            this.alert_msg = data.msg;
          } else {
            this.alert_msg = this.$t("component.form.unknown_error");
          }
          if (this.alert_msg) {
            this.$refs.alertModal.show();
          }
        })
        .finally(() => {
          this.source = null;
          this.loading = false;
          this.onCaptchaExpired();
        });
    }
  }
};
</script>
<style lang="scss" src="../assets/scss/form.scss"></style>
